import datosStore from './datos-store';
import facturaStore from './factura-store';
import formulariosStore from './formularios-store';
import importadoresStore, { importadoresFormStore } from './importadores-store';
import mercaderiaStore from './mercaderia-store';
import personasStore, { personasFormStore } from './persona-store';

datosStore.list.orderData.orders = {
  id: 'desc'
};

mercaderiaStore.list.orderData.orders = {
  id: 'desc'
};

formulariosStore.list.orderData.orders = {
  id: 'desc'
};

importadoresStore.list.orderData.orders = {
  id: 'desc'
};

importadoresFormStore.list.orderData.orders = {
  id: 'desc'
};

personasStore.list.orderData.orders = {
  nombre: 'desc'
};

personasFormStore.list.orderData.orders = {
  nombre: 'desc'
};

export default {
  datos: datosStore,
  mercaderia: mercaderiaStore,
  factura: facturaStore,
  formularios: formulariosStore,
  importadores: importadoresStore,
  importadoresForm: importadoresFormStore,
  personas: personasStore,
  personasForm: personasFormStore
};
